<template>
  <TheNavbar />

  <div v-if="justSubscribed" class="row justify-content-center mt-4 mb-4">
    <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
      
      <div class="alert alert-success border-0 d-flex align-items-center mb-0" role="alert">
        <div class="bg-success me-3 icon-item"><span class="fas fa-check-circle text-white fs-6"></span></div>
        <p class="mb-0 flex-1">
          <span class="fw-bold">WELCOME to SIGNUM 🥳</span><br>
          We are thrilled to have you with us ❤️ and wish you good fortune 🙏🏼
        </p>
      </div>

    </div>
  </div>

  <div v-if="userProfile" class="mt-4 mb-5">

    <div class="row justify-content-center mb-4">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
        <div class="card">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">Manage my subscription</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary p-0">

            <!-- User has a subscription -->
            <div v-if="userProfile.subscriptionActive && userProfile.stripeProductId" class="row justify-content-center p-4">
              <div class="col-4">
                <img class="img-fluid" src="@/assets/stripe/stripe_logo.png" />
              </div>
              <div class="col-8">
                <p>
                  <span class="fw-bold">You are subscribed</span> 🥳
                </p>
                <p v-if="userProfile.stripeSubscriptionEndAt">
                  <span class="fas fa-exclamation-triangle me-1"></span>
                  Your subscription is canceled and will end on:<br/>
                  <span class="fw-bold">{{ getPrettyDateText(userProfile.stripeSubscriptionEndAt) }}</span>
                </p>
                <p v-if="userProfile.subscriptionStatus === 'grace'" class="text-warning">
                  <span class="fas fa-exclamation-triangle me-1"></span>
                  There was a payment issue!<br/>
                  Stripe will retry for 2 weeks and cancel your subscription if it cannot collect the payment. Please visit the <span class="fw-bold">Stripe Customer Portal</span> to update your payment method.
                </p>

                <!-- <p>
                  Your subscription is: <span class="fw-bold">{{ getUserSubscribedProduct()?.title }}</span>
                </p> -->
                <p>
                  We use <span class="fw-bold">Stripe</span> for payment processing.
                </p>
                <p>In the <span class="fw-bold">Stripe Customer Portal</span> you can <span class="fw-bold">download your invoices</span>, <span class="fw-bold">manage your payment methods</span> and <span class="fw-bold">upgrade or cancel your subscription</span> at any time.</p>

                <a @click="goToStripeCustomerPortal()" target="_blank" class="btn btn-primary btn-sm" type="button">
                  <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-2"></span>
                  Stripe Customer Portal
                </a>
              </div>
            </div> <!-- row -->
            
            <!-- User has NO subscription -->
            <div v-if="userProfile.subscriptionStatus == 'trial' || userProfile.subscriptionStatus == 'canceled' || !userProfile.subscriptionActive" class="row g-0">

              <div class="col-lg-12 border-top border-bottom_ p-3 text-center">

                <div v-if="userProfile.isAutotradingUser" class="mt-3">
                  <div v-if="userProfile?.subscriptionStatus == 'canceled'">
                    <p>
                      <span class="fw-bold">You subscription has ended!</span><br>
                      <br>
                      Make sure to subscribe again if you want your trades to be executed.
                    </p>  
                  </div>
                  <div v-else-if="userProfile?.subscriptionTrialLeftSec == 0">
                    <p>
                      <span class="fw-bold">Your 12-months free usage of SIGNUM has ended.</span><br>
                      Choose a plan from below to continue using SIGNUM.<br>
                      <br>
                      Your trades have stopped executing! Take care 🙏🏼
                    </p>
                  </div>
                  <div v-else-if="userProfile?.subscriptionTrialLeftSec > 0">
                    <p>
                      You are an <span class="fw-bold">AutoTrading.vip Member</span>, so you don't need to subscribe until:<br>
                      <span class="fw-bold">{{ getPrettyDateText(userProfile?.subscriptionTrialEndAt) }}</span>
                    </p>
                    <!-- <img class="img-fluid" src="@/assets/subscribe/autotrading_logo.png" /> -->
                  </div>
                  <div v-else>
                    <p class="mt-3">At SIGNUM, we keep it simple. One subscription to rule them all 🤩</p>
                  </div>

                </div>
                <div v-else-if="!userProfile.isAutotradingUser" class="mt-3">
                  <div v-if="showCoupon && isCouponActive" class="mb-3">
                    <!-- <img class="img-fluid" src="@/assets/subscription/easter2026.png" /><br> -->
                    <video autoplay loop muted playsinline width="100%">
                      <source :src="require('@/assets/subscription/mothers2026.mp4')" type="video/mp4">
                    </video><br>
                    Use this coupon code at checkout: <input class="text-start border-0 fw-bold" style="background-color: transparent;" type="text" size="16" value="YOMAMA2026" />
                  </div>
                  <div v-else-if="showCoupon" class="mb-3">
                    <img class="img-fluid" src="@/assets/subscription/evergreen_v1.gif" /><br>
                    Use this coupon code at checkout: <input class="text-start border-0 fw-bold" style="background-color: transparent;" type="text" size="14" value="AUTOMATE4LIFE" />
                  </div>
                  
                  <div v-if="userProfile?.subscriptionStatus == 'canceled'">
                    <p>
                      <span class="fw-bold">You subscription has ended!</span><br>
                      <br>
                      Make sure to subscribe again if you want your trades to be executed.
                    </p>  
                  </div>
                  <div v-else-if="userProfile?.subscriptionTrialLeftSec == 0">
                    <p>
                      <span class="fw-bold">Your 14-day Trial period has has ended.</span>
                      <br>Choose a plan from below to continue using SIGNUM.<br>
                      <br>
                      Your trades have stopped executing! Take care 🙏🏼
                    </p>
                  </div>
                  <div v-else-if="userProfile?.subscriptionTrialLeftSec <= 1209600">
                    <p>
                      You are on a Trial, which will end on:<br>
                      <span class="fw-bold">{{ getPrettyDateText(userProfile?.subscriptionTrialEndAt) }}</span><br>
                      <br>
                      Make sure to subscribe before it ends so your trades don't stop.
                    </p>  
                  </div>
                  <div v-else-if="userProfile?.subscriptionTrialLeftSec > 1209600">
                    <p>
                      You are free to use SIGNUM without subscribing until you've made your first trade.<br>
                      <br>
                      After that your 14-Day Free Trial will start and you can trade freely during that time.<br>
                      Once the Trial is over, you have to subscribe to continue trading.
                    </p>
                  </div>
                </div>
                <div v-else>
                  <p class="mt-3">At SIGNUM, we keep it simple. One subscription to rule them all 🤩</p>
                </div>

              </div>

              <div v-if="getsAutotradingDiscount" class="col-lg-6 border-top border-bottom">
                <div class="h-100">
                  <div class="text-center p-4">
                    <h3 class="fw-normal my-0">AutoTrading Monthly (-40%)</h3>
                    <p class="mt-3">
                      As a valued AutoTrading member, you are getting a very special deal 🥳<br>
                      -40% OFF normal prices.
                    </p>
                    <h2 class="fw-medium my-4"> <sup class="fw-normal fs-7 me-1">$</sup>15<small class="fs-10 text-700">/ month</small>
                    </h2>
                    <a v-if="trialPeriodAlmostEnded" class="btn btn-primary" :href="getSubscribeUrl('monthly')" target="_blank">
                      <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-2"></span> Subscribe
                    </a>
                    <a v-else class="btn btn-dark disabled" title="No need to subscribe yet">
                      <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-2"></span> Not yet needed
                    </a>
                  </div>
                  <hr class="border-bottom-0 m-0">
                  <div class="text-start px-4 py-4">
                    <h5 class="fw-medium fs-9">Included:</h5>
                    <ul class="list-unstyled mt-3">
                      <li class="py-1">
                        <span class="me-2 fas fa-check text-success"></span> max. 50 Bots
                      </li>
                      <li class="py-1">
                        <span class="me-2 fas fa-check text-success"></span> Trend Radar (Preview)
                      </li>
                      <li class="py-1">
                        <span class="me-2 fas fa-check text-success"></span> No other limits
                      </li>
                      <li class="py-1">
                        <span class="me-2 fas fa-check text-success"></span> Fair use (don't spam)
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div v-if="getsAutotradingDiscount" class="col-lg-6 border-top border-bottom" style="background-color: rgba(115, 255, 236, 0.18);">
                <div class="h-100">
                  <div class="text-center p-4">
                    <h3 class="fw-normal my-0">AutoTrading Yearly (-40%)</h3>
                    <p class="mt-3">
                      As a valued AutoTrading member, you are getting a very special deal 🥳<br>
                      -40% OFF normal prices.
                    </p>
                    <h2 class="fw-medium my-4">
                      <sup class="fw-normal fs-7 me-1">$</sup>135<small class="fs-10 text-700">/ year</small>
                    </h2>
                    <a v-if="trialPeriodAlmostEnded" class="btn btn-primary" :href="getSubscribeUrl('yearly')" target="_blank">
                      <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-2"></span> Subscribe
                    </a>
                    <a v-else class="btn btn-dark disabled" title="No need to subscribe yet">
                      <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-2"></span> Not yet needed
                    </a>
                  </div>
                  <hr class="border-bottom-0 m-0">
                  <div class="text-start px-4 py-4">
                    <h5 class="fw-medium fs-9">Included:</h5>
                    <ul class="list-unstyled mt-3">
                      <li class="py-1">
                        <span class="me-2 fas fa-check text-success"></span> max. 50 Bots
                      </li>
                      <li class="py-1">
                        <span class="me-2 fas fa-check text-success"></span> Trend Radar (Preview)
                      </li>
                      <li class="py-1">
                        <span class="me-2 fas fa-check text-success"></span> No other limits
                      </li>
                      <li class="py-1">
                        <span class="me-2 fas fa-check text-success"></span> Fair use (don't spam)
                      </li>
                    </ul>
                  </div>
                </div>
              </div>


              <div v-if="!getsAutotradingDiscount" class="col-lg-6 border-top border-bottom">
                <div class="h-100">
                  <div class="text-center p-4">
                    <h3 class="fw-normal my-0">BASIC Monthly</h3>
                    <p class="mt-3">Automate your strategies with ease.</p>
                    <h2 class="fw-medium my-4"> <sup class="fw-normal fs-7 me-1">$</sup>25<small class="fs-10 text-700">/ month</small>
                    </h2>
                    <a class="btn btn-primary" :href="getSubscribeUrl('monthly')" target="_blank">
                      <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-2"></span>
                      Get BASIC Monthly
                    </a>
                  </div>
                  <hr class="border-bottom-0 m-0">
                  <div class="text-start px-4 py-4">
                    <h5 class="fw-medium fs-9">Included:</h5>
                    <ul class="list-unstyled mt-3">
                      <li class="py-1">
                        <span class="me-2 fas fa-check text-success"></span> max. 25 Bots
                      </li>
                      <li class="py-1">
                        <span class="me-2 fas fa-check text-success"></span> Trend Radar (Preview)
                      </li>
                      <li class="py-1">
                        <span class="me-2 fas fa-check text-success"></span> No other limits
                      </li>
                      <li class="py-1">
                        <span class="me-2 fas fa-check text-success"></span> Fair use (don't spam)
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div v-if="!getsAutotradingDiscount" class="col-lg-6 border-top border-bottom" style="background-color: rgba(115, 255, 236, 0.18);">
                <div class="h-100">
                  <div class="text-center p-4">
                    <h3 class="fw-normal my-0">BASIC Yearly (-25%)</h3>
                    <p class="mt-3">Automate your strategies with ease.</p>
                    <h2 class="fw-medium my-4">
                      <sup class="fw-normal fs-7 me-1">$</sup>225<small class="fs-10 text-700">/ year</small>
                    </h2>
                    <a class="btn btn-primary" :href="getSubscribeUrl('yearly')" target="_blank">
                      <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-2"></span>
                      Get BASIC Yearly
                    </a>
                  </div>
                  <hr class="border-bottom-0 m-0">
                  <div class="text-start px-4 py-4">
                    <h5 class="fw-medium fs-9">Included:</h5>
                    <ul class="list-unstyled mt-3">
                      <li class="py-1">
                        <span class="me-2 fas fa-check text-success"></span> max. 25 Bots
                      </li>
                      <li class="py-1">
                        <span class="me-2 fas fa-check text-success"></span> Trend Radar (Preview)
                      </li>
                      <li class="py-1">
                        <span class="me-2 fas fa-check text-success"></span> No other limits
                      </li>
                      <li class="py-1">
                        <span class="me-2 fas fa-check text-success"></span> Fair use (don't spam)
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

            </div> <!-- row -->

          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center mb-4">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
        <div class="card">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">Get Help</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary">
            <div>
              <TheHelpChatbot />
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import TheNavbar from '@/components/TheNavbar'
import TheHelpChatbot from '@/components/TheHelpChatbot'

export default {
  components: {
    TheNavbar,
    TheHelpChatbot
  },
  computed: {
    userProfile () {
      return this.$store.getters.getUserProfile
    },
    justSubscribed () {
      return this.$route.query.justSubscribed
    },
    isCouponActive () {
      const expiryDate = new Date('2026-05-18T23:59:59.000+00:00') // Dubai timezone would be "+04:00"
      const nowDate = new Date()

      return (nowDate.getTime() > expiryDate.getTime()) ? false : true
    },
    showCoupon () {
      // 23091 = rhilke@go4extreme.com - ex-AT member who wants to keep using SIGNUM but we don't want him to get a discount
      return ![23091].includes(this.userProfile?.id)
    },
    getsAutotradingDiscount () {
      // Use this to disable the AutoTrading Discount when needed.
      // 25581 = Mirko got manually granted AutoTrading features (is_autotrading_user flag) but should NOT get the AutoTrading discount
      return this.userProfile?.isAutotradingUser && ![25581].includes(this.userProfile?.id)
    },
    trialPeriodAlmostEnded() {
      const plusDays = 7
      const trialEndDate = new Date(this.userProfile?.subscriptionTrialEndAt)
      const nowDate = new Date()

      if (plusDays > 0) nowDate.setDate(nowDate.getDate() + plusDays)
      console.log("nowDate", nowDate)
      console.log("trialEndDate", trialEndDate)

      return (nowDate.getTime() > trialEndDate.getTime()) ? true : false
    }
  },
  methods: {
    getUserSubscribedProduct () {
      const products = {
        prod_QGftbFzc9z4vC9: {
          title: "SIGNUM Basic",
          maxBots: 25
        },
        prod_QaA3DUQkagAvYu: {
          title: "SIGNUM AutoTrading",
          maxBots: 25
        },
        prod_QZ0SXRTFuQaKnK: {
          title: "SIGNUM Basic (Tester)",
          maxBots: 25
        },
        prod_Qa9z62YRbEX0sd: {
          title: "SIGNUM AutoTrading (Tester)",
          maxBots: 25
        }
      }
      const stripeProductId = this.userProfile?.stripeProductId
      return products[stripeProductId]
    },
    async goToStripeCustomerPortal () {
      const stripeCustomerPortalSession = await this.$store.dispatch('getUserStripePortalSession')
      window.open(stripeCustomerPortalSession.url,'_blank');
    },
    getSubscribeUrl (period) {
      const userEmail = this.userProfile?.email
      const userId = this.userProfile?.id

      const urlParams = {
        'prefilled_email': userEmail,
        'client_reference_id': userId
      }
      
      let stripeSubUrl = process.env.VUE_APP_STRIPE_SUB_BASIC_MONTHLY_URL+'?'+this.encodeQueryData(urlParams)
      if (this.getsAutotradingDiscount) {
        if (period == 'monthly') {
          stripeSubUrl = process.env.VUE_APP_STRIPE_SUB_AUTOTRADING_MONTHLY_URL+'?'+this.encodeQueryData(urlParams)  
        } else {
          stripeSubUrl = process.env.VUE_APP_STRIPE_SUB_AUTOTRADING_YEARLY_URL+'?'+this.encodeQueryData(urlParams)
        }
      } else {
        if (period == 'monthly') {
          stripeSubUrl = process.env.VUE_APP_STRIPE_SUB_BASIC_MONTHLY_URL+'?'+this.encodeQueryData(urlParams)
        } else if (period == 'yearly') {
          stripeSubUrl = process.env.VUE_APP_STRIPE_SUB_BASIC_YEARLY_URL+'?'+this.encodeQueryData(urlParams)
        }
      }

      return stripeSubUrl
    },
    encodeQueryData(data) {
      const ret = [];
      for (let d in data)
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      return ret.join('&');
    },
    getPrettyDateText (someString) {
      const timestamp = Date.parse(someString);
      const dateObj = new Date(timestamp)
      return dateObj.toLocaleString(undefined, {year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', hour12: false, minute:'2-digit', second:'2-digit'})
    }
  },
  beforeMount () {
    // Redirect to Login when the user is not logged in
    if (!this.$store.getters.isUserLoggedIn) this.$router.push({ name: 'Login' })

    if (this.$route.query.justSubscribed) {
      this.$confetti.start()
      setTimeout(() => {
        this.$confetti.stop()
      }, "5000");
    }
  },
  async mounted () {
    // Fetch the sripe portal session when needed (to be sure it's there)
    if (this.userProfile && this.userProfile?.subscriptionActive && this.userProfile?.stripeProductId) {
      if (!this.$store.getters.getUserStripePortalSession) await this.$store.dispatch('getUserStripePortalSession')
    }
  }
  
}
</script>

<style scoped>

</style>